import {
    GA_SCREEN_HOMEPAGE,
    GA_SCREEN_LANDING_PAGE,
    GA_SCREEN_FRONT_PAGE,
    GA_SCREEN_ENTRY_PAGE,
    GA_SCREEN_LISTING,
    GA_SCREEN_PRODUCT,
    GA_SCREEN_MAGAZINE
} from '@common/Tracking/constants/GaScreenNames';

export const DL_SHOW_NAV_ID = [
    GA_SCREEN_LISTING,
    GA_SCREEN_HOMEPAGE,
    GA_SCREEN_LANDING_PAGE,
    GA_SCREEN_ENTRY_PAGE,
    GA_SCREEN_FRONT_PAGE,
    GA_SCREEN_MAGAZINE
];

export const DL_SHOW_BREADCRUMB_PATH = [
    GA_SCREEN_LISTING,
    GA_SCREEN_LANDING_PAGE,
    GA_SCREEN_ENTRY_PAGE,
    GA_SCREEN_FRONT_PAGE,
    GA_SCREEN_MAGAZINE
];

export const DL_SHOW_PATH_ID = [
    GA_SCREEN_LISTING,
    GA_SCREEN_LANDING_PAGE,
    GA_SCREEN_ENTRY_PAGE,
    GA_SCREEN_FRONT_PAGE,
    GA_SCREEN_MAGAZINE
];

export const DL_SHOW_TOP_NAV = [
    GA_SCREEN_LISTING,
    GA_SCREEN_HOMEPAGE,
    GA_SCREEN_LANDING_PAGE,
    GA_SCREEN_ENTRY_PAGE,
    GA_SCREEN_FRONT_PAGE,
    GA_SCREEN_PRODUCT,
    GA_SCREEN_MAGAZINE
];
